<template>
  <div class="c-app" :class="{ 'c-dark-theme': $store.state.darkMode }">
    <TheSidebar/>
    <!--    <TheAside/>-->
    <CWrapper ref="navWrapper">
      <div class="fixed-notification"
           id="notificationFixed">
        <!-- <marquee behavior="scroll" direction="left" v-if="isShowNotificationEmergency">
          Địa bàn của bạn đang có bản tin vừa được đặt khẩn cấp từ người dùng cấp trên -
          <b>{{ notificationEmergency.locationName }}</b>.
          Bản tin sẽ kết thúc vào lúc <b>{{ notificationEmergency.times }}</b>, trên các thiết bị :
          <b>
            <template v-for="each in viewDevice(notificationEmergency.devices)">
              {{ each + ", " }}
            </template>
            <template v-if="notificationEmergency.devices.length > maxDisplayDeviceTable">...</template>
          </b>
          nếu người dùng đang phát trực tiếp, vui lòng kết thúc nếu không cần thiết để bản tin không bị gián đoạn!
        </marquee>
        <marquee v-else>
          Hôm nay, {{ showNotification }}. Chúc người dùng có 1 ngày làm việc hiệu quả và thành
          công.
          Nếu có bất cứ vấn đề liên quan đến hệ thống, vui lòng liên hệ theo số hotline: <b>Mr.Quyết - 0933328386</b>.
        </marquee> -->
        <!-- <marquee v-if="isShowNotificationEmergency" :text="combinedNotificationEmergencyText()" :loop="true" :translateX="['100%', '-100%']" :easing="'linear'" :backgroundColor="'red'">
        </marquee>
        <marquee v-else :text="combinedNotificationNormalText()" :loop="true" :translateX="['100%', '-100%']" :easing="'linear'" :backgroundColor="'#2d8be0'">
        </marquee> -->
      </div>
      <TheHeader/>
      <div class="c-body" id="headerNav">
        <CModal title="Kiểm tra log thiết bị"
            :show.sync="isShowModalLogDevice"
            :closeOnBackdrop="false" :size="'sm'">
          <CRow class="pb-2">
            <span style="font-weight: bold;">Bạn có muốn tải file log xuống không?</span>
          </CRow>
          <template v-slot:footer>
            <button type="button" class="btn btn-secondary" @click="isShowModalLogDevice = false"><i class="fa fa-times"></i> Hủy bỏ
            </button>
            <button type="button" class="btn btn-primary" @click="downLoadLog()"><i class="fa fa-check"></i>
              Có
            </button>
          </template>
        </CModal>
        <main class="c-main mt-1">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAside from './TheAside'
import {authLogout, authAutoLogout} from "@/security/index";
import {ACCESS_TOKEN_EXPIRED, NOTIFICATION_EMERGENCY} from '../constant'
import Marquee from '@/views/base/Marquee.vue';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    TheAside,
    Marquee
  },
  data() {
    return {
      intervalAutoLogout: null,
      intervalTimes: null,
      intervalHiddenNotification: null,
      showNotification: this.$helper.formatDateDetail(new Date()),
      isShowNotificationEmergency: false,
      notificationEmergency: null,
      maxDisplayDeviceTable: 5,
      isShowModalLogDevice: false,
      log: {
        deviceCode: '',
        logUri: ''
      }
    }
  },
  mounted() {
    // this.scrollNotification();
    this.countAutoLogout();
    // this.connectWebSocket();
    this.countdownTimes();

    // if (localStorage.getItem(NOTIFICATION_EMERGENCY) != null) {
    //   this.isShowNotificationEmergency = true;
    //   this.notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
    // }

  },
  methods: {
    combinedNotificationEmergencyText() {

      var devices = this.viewDevice(this.notificationEmergency.devices);

      var deviceString = "";

      for(var i = 0; i < devices.length; i++) {
        deviceString = deviceString + devices[i] + ", "
      }

      if(this.notificationEmergency.devices.length > this.maxDisplayDeviceTable) {
        deviceString += "..."
      }

      return `Địa bàn của bạn đang có bản tin vừa được đặt khẩn cấp từ người dùng cấp trên - ${this.notificationEmergency.locationName}. Bản tin sẽ kết thúc vào lúc ${this.notificationEmergency.times}, trên các thiết bị : `+ deviceString + `nếu người dùng đang phát trực tiếp, vui lòng kết thúc nếu không cần thiết để bản tin không bị gián đoạn!`;
    },
    combinedNotificationNormalText() {
      return `Hôm nay, ${this.showNotification}. Chúc người dùng có 1 ngày làm việc hiệu quả và thành công. Nếu có bất cứ vấn đề liên quan đến hệ thống hoặc hư hỏng, vui lòng liên hệ theo số hotline: Mr.Thái - 0983140665`;
    },
    countdownShowNotification() {
      this.intervalHiddenNotification = setInterval(() => {
        var notificationEmergency = JSON.parse(localStorage.getItem(NOTIFICATION_EMERGENCY));
        if (notificationEmergency != null && notificationEmergency.timeExpired != null) {
          if (new Date(notificationEmergency.timeExpired) <= new Date()) {
            this.isShowNotificationEmergency = false;
            localStorage.removeItem(NOTIFICATION_EMERGENCY);
          }
        } else {
          this.isShowNotificationEmergency = false;
          clearInterval(this.intervalHiddenNotification);
        }
      }, 1000);
    },
    countdownTimes() {
      this.intervalTimes = setInterval(() => {
        this.showNotification = this.$helper.formatDateDetail(new Date());
      }, 1000);
    },
    viewDevice(item) {
      if (!item) {
        return [];
      }
      if (item.length <= this.maxDisplayDeviceTable) {
        return item;
      }
      return item.slice(0, this.maxDisplayDeviceTable);
    },
    scrollNotification() {
      window.addEventListener('scroll', () => {
        var doc = document.getElementById('headerNav');
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
        if (top <= 10) {
          document.getElementById("notificationFixed").style.position = '';
        } else {
          document.getElementById("notificationFixed").style.position = 'fixed';
        }
      });
    },
    countAutoLogout() {
      let that = this;
      let exp_token = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (exp_token) {
        let expiredTime = new Date(exp_token * 1)
        this.intervalAutoLogout = setInterval(() => {
          let time = new Date();
          if (time >= expiredTime) {
            authAutoLogout();
          }
        }, 1000)
      }
    },
    downLoadLog() {
      this.isShowModalLogDevice = false;
      if(this.log.logUri && this.log.logUri.length > 0) {
        // this.$helper.downloadLog(this.log.logUri, 'LOG_' + this.log.deviceCode + '.log');
        window.open(this.log.logUri, "_blank");
      }
      setTimeout(() => {
        this.log.logUri = '';
      }, 1000)
      
    },
    connectWebSocket: function () {
      let that = this
      that.$connectSocket(successCallback => {
        if (successCallback) {
          successCallback.subscribe("/user/notification", notification => {
            that.$store.commit('setDataNotification', notification)
          });
          that.$sendMessageSocket("/app/server.message.notification", null, {})

          successCallback.subscribe("/notification", notification => {
            // console.log(notification)
            that.$store.commit('setDataNotification', notification)
          });
          successCallback.subscribe("/ping", ping => {
          });
          
          successCallback.subscribe("/user/devices/get-log", logDevice => {
            let data = JSON.parse(logDevice.body)
            that.log.deviceCode = data.deviceCode;
            that.log.logUri = data.urlLog;
            if(that.$store.state.logDevice) {
              that.isShowModalLogDevice = true;
            }
            // that.$store.commit('setLogDevice', data)
          });
        }
      }, errorCallback => {
        console.log(errorCallback)
      })
    },
  },
  destroyed() {
    clearInterval(this.intervalAutoLogout);
    clearInterval(this.intervalTimes);
  },
  computed: {},
  watch: {
    // '$store.state.reconnectSocket': function (value) {
    //   if (value) {
    //     this.connectWebSocket();
    //   }
    //   this.$store.commit("set", ["reconnectSocket", false])
    // },
  }
}
</script>

<style scoped>
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
